<template>
  <main-layout class="batch-print" page-title="补贴测算">
    <div slot="main-content" class="main-content">
      <div class="page">
        <div class="alert">
          <i class="el-icon-warning"></i>
          补贴数据均为预算数据，最终按实际为主，数据截止于昨日
        </div>
        <div class="page-header">
          <el-date-picker
            v-model="queryParams.archiveYear"
            size="medium"
            type="year"
            value-format="yyyy"
            format="yyyy年"
            :clearable="false"
            :picker-options="pickerDateOptions"
            @change="handleChange"
            placeholder="请选择年份"
          >
          </el-date-picker>
          <el-select
            v-model="queryParams.cropId"
            size="medium"
            filterable
            clearable
            @change="handleChange"
            placeholder="请选择种养品种"
          >
            <el-option
              v-for="cropGroup in cropGroupList"
              :key="cropGroup.id"
              :value="cropGroup.id"
              :label="cropGroup.cropName"
            ></el-option>
          </el-select>
          <el-input
            v-model="queryParams.keyword"
            size="medium"
            placeholder="请输入地块名称或地块编号"
            prefix-icon="el-icon-search"
            @input="handleChangeDebounce"
          />
        </div>
        <div class="exhibit">
          <div class="exhibit-logo">
            <img src="~@/assets/images/subsidy/logo.png" alt="" />
            <div class="txt">蔬菜补贴面积测算</div>
          </div>
          <div class="exhibit-item">
            <div class="title">蔬菜补贴面积</div>
            <div class="num">
              <span>{{ acreTotal }}</span>
              <span class="val">亩次</span>
            </div>
          </div>
          <div class="exhibit-item last">
            <div class="title">补贴地块数</div>
            <div class="num">
              <span>{{ total }}</span>
              <span class="val">块</span>
            </div>
          </div>
        </div>
        <el-table
          v-if="!isShowEmpty"
          ref="multipleTable"
          class="page-table"
          empty-text=" "
          v-loading="tableLoading"
          :data="dataList"
          stripe
          height="calc(100vh - 443px)"
          :row-class-name="TableRow"
          :header-cell-style="{ color: '#64C3A4', fontSize: '16px' }"
          :cell-style="{ color: '#666666' }"
        >
          <el-table-column label="地块名称（地块编号）" prop="landName" />
          <el-table-column
            label="补贴年份"
            prop="archiveYear"
            :formatter="(row) => `${row.archiveYear}年`"
            width="150"
          />
          <el-table-column label="作物" prop="cropNames" show-overflow-tooltip>
            <template slot-scope="scope">
              <span v-for="(item, idx) in scope.row.cropNames" :key="idx"
                >{{ item
                }}{{ idx === scope.row.cropNames.length - 1 ? "" : "," }}
              </span>
            </template>
          </el-table-column>
          <el-table-column label="补贴茬口数" prop="xy" width="120" />
          <el-table-column
            label="补贴面积（亩次）"
            prop="subsidyAcreTotal"
            width="150"
          />
          <el-table-column label="操作" width="120">
            <template slot-scope="scope">
              <el-button type="text" @click="checkInfo(scope.row)"
                >明细</el-button
              >
            </template>
          </el-table-column>
        </el-table>
        <div class="noDataImg" v-else>
          <div class="imgNo">
            <img
              src="@/assets/images/aviatFarmingList/batch-nodata.png"
              alt=""
            />
          </div>
          <p style="color: #333; margin-bottom: 20px">暂无数据</p>
        </div>
        <el-pagination
          v-if="!isShowEmpty"
          :total="total"
          background
          :current-page="queryParams.pageNo"
          :page-size="queryParams.pageSize"
          @current-change="currentChange"
          @size-change="sizePageChange"
          layout="total, prev, pager, next"
        />
      </div>
      <el-dialog
        title="蔬菜补贴明细"
        class="print-dialog"
        center
        width="860px"
        :visible.sync="printDialogVisible"
      >
        <div class="list-box">
          <el-table
            :data="tableData"
            style="width: 100%"
            :header-row-style="{ color: '#64c3a4' }"
          >
            <el-table-column prop="cropName" label="作物名称">
            </el-table-column>
            <el-table-column prop="plantStartDate" label="种植周期">
              <template slot-scope="scope">
                <div>
                  <span>{{
                    scope.row.plantStartDate | formatDate("yyyy.MM.dd")
                  }}</span>
                  <span> 至 </span>
                  <span>{{
                    scope.row.plantCloseDate | formatDate("yyyy.MM.dd")
                  }}</span>
                </div>
              </template>
            </el-table-column>
            <el-table-column label="是否绿叶菜" width="100">
              <template slot-scope="scope">
                <div>{{ scope.row.lvyecaiFlag ? "是" : "否" }}</div>
              </template>
            </el-table-column>
          </el-table>
          <!--          <el-pagination-->
          <!--            :total="tableData.length"-->
          <!--            background-->
          <!--            :current-page="queryParams.pageNo"-->
          <!--            :page-size="queryParams.pageSize"-->
          <!--            @current-change="currentChange"-->
          <!--            @size-change="sizePageChange"-->
          <!--            layout="total, prev, pager, next"-->
          <!--          />-->
        </div>
      </el-dialog>
    </div>
  </main-layout>
</template>

<script>
import MainLayout from "@/layout/MainLayout";
import {
  crop,
  getSubsidyStaticsList,
  getSubsidyStaticsDetail,
} from "@/api/request/snkd.produce";
import { debounce } from "@/utils";
import { mapActions } from "vuex";
import { getStorage } from "@/utils/storage";

export default {
  name: "batchPrint",
  components: {
    MainLayout,
  },
  data() {
    return {
      cropGroupList: [],
      dataList: [],
      tableData: [],
      queryParams: {
        pageNo: 1,
        pageSize: 10,
        keyword: "",
        cropId: "",
        archiveYear: "",
      },
      pickerDateOptions: {
        disabledDate(time) {
          return time.getTime() > Date.now();
        },
      },
      total: 0,
      acreTotal: 0,
      printDialogVisible: false,
      tableLoading: false,
      isShowEmpty: false,
    };
  },
  computed: {},
  created() {
    this.queryParams.archiveYear = new Date().getFullYear().toString();
    this.getList();
    this.getCropListHandle();
  },
  methods: {
    ...mapActions("permission", ["hasPermission"]),
    //获取作物品种列表
    async getCropListHandle() {
      const { companyId, farmId } = getStorage("FARMINFO");
      const res = await crop.listOfCurrencyService({
        companyId,
        farmId,
        cropSubjectIdentifierList: [],
      });
      this.cropGroupList = res || [];
    },
    getList() {
      this.tableLoading = true;
      const params = {
        ...this.queryParams,
      };
      getSubsidyStaticsList(params).then(({ obj }) => {
        this.dataList = obj ? obj.list : [];
        if (this.dataList.length) {
          const { landNum, subsidyAcreTotal } =
            this.dataList[0].coSubsidyTotalVO;
          this.total = landNum;
          this.acreTotal = subsidyAcreTotal;
        } else {
          this.total = 0;
          this.acreTotal = 0;
        }
        this.tableLoading = false;
        this.isShowEmpty = !this.dataList.length;
      });
    },
    //设置表格行的样式
    TableRow({ rowIndex }) {
      if (rowIndex % 2 === 0) {
        return "statistics-warning-row";
      } else {
        return "";
      }
    },
    // 输入框input 防抖
    handleChangeDebounce: debounce(async function () {
      this.queryParams.pageNo = 1;
      await this.getList();
    }),
    // 选择日期类型 chang方法
    handleChange() {
      this.queryParams.pageNo = 1;
      this.getList();
    },
    // 详情按钮
    checkInfo(row) {
      const { landId } = row;
      getSubsidyStaticsDetail({
        archiveYear: this.queryParams.archiveYear,
        landId,
      }).then((res) => {
        this.tableData = res.obj;
        this.printDialogVisible = true;
      });
    },
    // 页码单选
    currentChange(page) {
      this.queryParams.pageNo = page;
      this.getList();
    },
    // 分页数量
    sizePageChange(pages) {
      this.queryParams.pageNo = 1;
      this.queryParams.pageSize = pages;
      this.getList();
    },
  },
};
</script>

<style scoped lang="scss">
.batch-print {
  .main-content {
    width: 1200px;
    height: 100%;
    background: #fff;
    margin: 0 auto;
    display: flex;
    flex-direction: column;
    .page {
      min-height: 0;
      flex: 1;
      padding: 20px;
      .alert {
        padding: 9px 16px;
        border-radius: 2px;
        background: #fff;
        box-shadow: 0 4px 20px 2px rgba(0, 0, 0, 0.05);
        margin-bottom: 25px;
        color: rgba(0, 0, 0, 0.65);
        font-family: OPPOSans;
        font-size: 14px;
        font-style: normal;
        font-weight: 400;
        line-height: 22px;
        .el-icon-warning {
          font-size: 16px;
          color: #faad14;
        }
      }
      .exhibit {
        margin: 25px 0;
        border-radius: 10px;
        background: var(--unnamed, #fff);
        box-shadow: 0 5px 20px 0 rgba(85, 85, 124, 0.13);
        height: 140px;
        display: flex;
        align-items: center;
        &-logo {
          flex: 1.5;
          display: flex;
          align-items: center;
          justify-content: center;
          img {
            width: 40px;
            height: 40px;
            margin-right: 25px;
          }
          .txt {
            color: #2e333b;
            font-family: Microsoft YaHei;
            font-size: 24px;
            font-style: normal;
            font-weight: 700;
            line-height: normal;
          }
        }
        &-item {
          flex: 1;
          &.last {
            flex: 0.8;
          }
          .title {
            color: #2e333b;
            font-family: Microsoft YaHei;
            font-size: 18px;
            font-style: normal;
            font-weight: 400;
            line-height: normal;
          }
          .num {
            color: #2e333b;
            font-family: Poppins;
            font-size: 30px;
            font-style: normal;
            font-weight: 700;
            line-height: normal;
            margin-top: 24px;
            .val {
              color: #8490a2;
              font-family: Poppins;
              font-size: 14px;
              font-style: normal;
              font-weight: 400;
              line-height: normal;
              margin-left: 5px;
            }
          }
        }
      }
      &-header {
        display: flex;
        & > div {
          width: 220px;
          margin-right: 10px;
        }
        .right-btn {
          margin-left: auto;
          margin-right: 0;
          width: auto;
        }
        ::v-deep .el-date-editor--daterange {
          width: 250px;
        }
        input[type="number"]::-webkit-outer-spin-button,
        input[type="number"]::-webkit-inner-spin-button {
          -webkit-appearance: none !important;
        }
        input[type="number"] {
          -moz-appearance: textfield;
        }
      }
      &-table {
        margin-top: 10px;
        ::v-deep .hidden-label {
          opacity: 0;
        }
        .produce-box {
          display: flex;
          align-items: center;
          .produceImg {
            width: 35px;
            height: 35px;
            margin-right: 10px;
          }
        }
      }
      ::v-deep .el-pagination {
        text-align: right;
        margin-top: 10px;
      }
      ::v-deep .el-table td,
      ::v-deep .el-table th.is-leaf {
        border: none;
      }
    }
  }
  .print-dialog {
    ::v-deep .el-dialog {
      border-radius: 10px;
      .el-dialog__header {
        border-radius: 10px 10px 0 0;
        background-color: #64c3a4;
        color: #fff;
        padding: 15px 20px;
        .el-dialog__title,
        .el-dialog__close {
          color: #fff;
        }
      }
      .el-dialog__body {
        padding: 0;
        max-height: 500px;
        overflow-y: auto;
      }
    }
    .list-box {
      padding: 24px;
      ::v-deep .el-pagination {
        text-align: right;
        margin-top: 20px;
      }
      ::v-deep .el-table__header {
        th,
        tr {
          background: #f7f9fb;
        }
      }
    }
  }
}
</style>
